import { InjectionToken, Provider } from '@angular/core';

export const CUSTOM_COMPONENT_DATA = new InjectionToken('CUSTOM_COMPONENT_DATA');

/**
 * This data is sent to any custom component via the iframe (using `postMessage`) and made available
 * via `this.data` within the custom component class.
 */
export const customComponentDataProvider: Provider = {
  provide: CUSTOM_COMPONENT_DATA,
  useFactory: () => ({
    message: 'Hello!',
  }),
};
